import { httpPost, camelify } from '@/lib/api/rest';

export function createSession(httpPost) {
  return async function execute(token) {
    /* istanbul ignore next: development data */
    if (process.env.DEMO) {
      return '';
    }
    const { data } = await httpPost('/sessions', { token });
    return camelify(data);
  };
}

export default createSession(httpPost);
